import { DataViewTypes, ReportTypes, UserResourceTypes } from '@mode/shared/contract-common';
import { createReducer, on } from '@ngrx/store';
import * as ReportViewerActions from './report-viewer.actions';

export const reportViewerFeatureKey = 'reportViewer';

export interface ReportViewerFeatureState {
  accountUsername: string;
  colorMappings: any; // For now, this provides nothing, but it will be used when colors starts back up
  createdAt: string;
  creator: UserResourceTypes.UserResource | null;
  description: string;
  displayName: string;
  drilldownsEnabled: boolean;
  drillAnywhereEnabled: boolean;
  editedAt: string;
  expectedRuntime: number;
  filters: ReportTypes.ReportFilterResource[] | null;
  fullWidth: boolean;
  hasNotebook: boolean;
  hasSuccessfulReportRun: boolean;
  iframeSrc: string;
  isLatestReportRun: boolean;
  isLatestSuccessfulReportRun: boolean;
  lastRunAt: string;
  lastSavedAt: string; // Not sure what this is, the value was `null` in the example, but the report had clearly been saved...
  lastSuccessfulSyncAt: string; // Is this relevant? Maybe we get rid of it
  lastSuccessfullyRunAt: string;
  layout: string | null;
  manualRunDisabled: boolean;
  mostRecentReportRunToken: string;
  mostRecentReportRunState: string;
  name: string;
  parentReportName: string;
  parentReportLink: string;
  publishedAt: string;
  reportHasFailuresSinceLastSuccess: boolean;
  reportRunCompletedAt: string;
  reportRunFormFields: ReportTypes.ReportRunFormField[] | null;
  reportRunState: DataViewTypes.ReportRunStatus | null;
  reportRunToken: string;
  runPrivately: boolean;
  showFilterHeader: boolean;
  showReportHistory: boolean;
  spaceDefaultAccess: string | null | undefined;
  spaceName: string | undefined;
  spaceUrl: string | undefined;
  isSpaceViewable: boolean;
  isCollectionPersonal: boolean;
  isCollectionCommunity: boolean;
  theme: ReportTypes.ReportTheme | null;
  token: string;
  updatedAt: string;
  webLink: string;
  activeToastId?: number;
}

export const initialReportViewerFeatureState: ReportViewerFeatureState = {
  accountUsername: '',
  colorMappings: null, // For now, this provides nothing, but it will be used when colors starts back up
  createdAt: '',
  creator: null,
  description: '',
  displayName: '',
  drilldownsEnabled: false,
  drillAnywhereEnabled: false,
  editedAt: '',
  expectedRuntime: 0,
  filters: null,
  fullWidth: false,
  hasNotebook: false,
  hasSuccessfulReportRun: false,
  iframeSrc: '',
  isLatestReportRun: true,
  isLatestSuccessfulReportRun: true,
  lastRunAt: '',
  lastSavedAt: '', // Not sure what this is, the value was `null` in the example, but the report had clearly been saved...
  lastSuccessfulSyncAt: '', // Is this relevant? Maybe we get rid of it
  lastSuccessfullyRunAt: '',
  layout: null, // Null is a stronger 'not loaded' than an empty string, which theoretically could be valid
  manualRunDisabled: false,
  mostRecentReportRunState: '',
  mostRecentReportRunToken: '',
  name: '',
  parentReportName: '',
  parentReportLink: '',
  publishedAt: '',
  reportHasFailuresSinceLastSuccess: false,
  reportRunCompletedAt: '',
  reportRunFormFields: null,
  reportRunState: null,
  reportRunToken: '',
  runPrivately: false,
  showFilterHeader: false,
  showReportHistory: false,
  spaceDefaultAccess: null,
  spaceName: '',
  spaceUrl: '',
  isSpaceViewable: false,
  isCollectionCommunity: false,
  isCollectionPersonal: true,
  theme: null,
  token: '',
  updatedAt: '',
  webLink: '',
};

export const reducer = createReducer(
  initialReportViewerFeatureState,

  on(ReportViewerActions.loadFullReportSuccess, (state, action) => action.report),
  on(ReportViewerActions.reportLoading, (state, action) => ({
    ...state,
    activeToastId: action.toastId,
  }))
);
